import { render, staticRenderFns } from "./giftedUsers.vue?vue&type=template&id=48302285&scoped=true"
import script from "./giftedUsers.vue?vue&type=script&lang=js"
export * from "./giftedUsers.vue?vue&type=script&lang=js"
import style0 from "./giftedUsers.vue?vue&type=style&index=0&id=48302285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48302285",
  null
  
)

export default component.exports